import React, { useState, useEffect } from 'react';
import {
  Select,
  MenuItem,
  CircularProgress,
  FormControl,
  InputLabel,
} from '@mui/material';
import regionApi from '../../api/region.api';
import { IRegion } from '../../models/region.model';

type Props = {
  value?: string | null;
  onChange?: (value: IRegion | null) => void;
};

const RegionSelect = (props: Props) => {
  const [dropdownItems, setDropdownItems] = useState<IRegion[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    // Simulate initial load or trigger load on component mount
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await regionApi.getAll();

      setDropdownItems(res.data);
    } catch (error) {
      console.error('Error fetching dropdown items:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormControl fullWidth>
      <InputLabel>Region</InputLabel>
      <Select
        size="small"
        label="Region"
        value={props.value || 'no-region'}
        onChange={(e) => {
          if (e.target.value === 'no-region') {
            props.onChange?.(null);
          }
          const item = dropdownItems.find((i) => i.id === e.target.value);
          if (item) {
            props.onChange?.(item);
          }
        }} // Handle select change here
        displayEmpty
        renderValue={(selected) => {
          if (selected === 'no-region') {
            return 'Select an item';
          }
          const item = dropdownItems.find((i) => i.id === selected);

          return item?.name || 'Select an item';
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={24} />
          </MenuItem>
        ) : (
          <MenuItem key={'empty'} value={'no-region'}>
            No Region
          </MenuItem>
        )}
        {!loading &&
          dropdownItems.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default RegionSelect;
